import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import SubMenu from "../../../components/side-nav-bar/sub-menus";
import SubMenuCourses from "../../../components/side-nav-bar/sub-menus/containers/courses/containers/sub-menu/SubMenuCourses";
import { Route, Switch } from "react-router-dom";
import Workshops from "./containers/workshops/Workshops";
import Curriculum from "./containers/curriculum/containers/Curriculums";
import CreateWorkshop from "./containers/create-workshop/CreateWorkshop";
import { useAppUser } from "../../../../../contexts/user-context/UserContext";
import LibraryHome from "./containers/library-home/containers/LibraryHome";
import Login from "../../../../login/container";

export enum DashboardLibraryPages {
  HOME = "/dashboard/library",
  WORKSHOPS = "/dashboard/library/workshops",
  CURRICULUM = "/dashboard/library/curriculums",
  CREATE_NEW_WORKSHOP = "/dashboard/library/createnewworkshop",
}

const LibraryRoutes = () => {
  const appUser = useAppUser();

  return (
    <div className="dashboard-library-wrapper">
      <SubMenu>
        <SubMenuCourses type="PRIVATE" />
      </SubMenu>
      <Container fluid className="course-wrapper pt-0">
        <Row>
          <Col md={12} lg={12} sm={12}>
            <Switch>
              <Route path={DashboardLibraryPages.HOME} exact>
                <LibraryHome />
              </Route>
            </Switch>
            <Switch>
              <Route path={DashboardLibraryPages.CURRICULUM}>
                <Curriculum />
              </Route>
              <Route path={DashboardLibraryPages.WORKSHOPS}>
                <Workshops />
              </Route>
              <Route
                path={DashboardLibraryPages.CREATE_NEW_WORKSHOP}
                component={() => {
                  if (
                    appUser.fireUser &&
                    (appUser.userRole.isAdmin || appUser.userRole.isModerator)
                  ) {
                    return <CreateWorkshop />;
                  } else {
                    return <Login />;
                  }
                }}
              />
            </Switch>
          </Col>
          <Col md={3} lg={2} style={{ borderLeft: "solid 1px #333" }}></Col>
        </Row>
      </Container>
    </div>
  );
};

export default LibraryRoutes;
